import React from 'react';
import BaseStep from './BaseStep';
import GroupStep from './GroupStep';
import CategoriesStep from './CategoriesStep';
import OutputsStep from './OutputsStep';

const ConfigSteps = () => {
  return (
    <>
      <BaseStep />
      <GroupStep />
      <CategoriesStep />
      <OutputsStep />
    </>
  );
};

export default ConfigSteps;
